import { isGroupOnly } from '_legacy/utils/Visibility';
import Logger from '../../../diagnostics/logging/logger';
import MixpanelLogger from '../../../diagnostics/logging/mixpanelLogger';
import { cloneDeep } from 'lodash';

export const createDeleteMenuItem = (props, node, gridId) => {
    const { group, data } = node;
    const { id, privacy, visibility, __typename: typeName } = data;
    const { selectedGroup } = props;

    const title = 'Delete';
    const tooltip = 'Delete this row';
    const groupOnly = isGroupOnly(visibility);
    return {
        name: title,
        action: () => {
            if (!group && data) {
                Logger.trackEvent('grid.context.delete', gridId);
                MixpanelLogger.trackDeleteItemEvent(
                    id,
                    typeName,
                    groupOnly,
                    privacy,
                    selectedGroup.name
                );

                const clonedData = cloneDeep(data);
                props.onDelete(clonedData);
            }
        },
        tooltip: tooltip,
    };
};
